import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { redirect } from 'next/navigation';

import { publicEnv } from '@/lib/env';
import { NO_RESULTS_MODULE_MESSAGES } from '@/modules/players/v2/tabs/constants';
import { ModuleType, PlayerData } from '@/types/players.types';

interface NoResultsConfigProps {
  moduleType: ModuleType;
  isManage: boolean;
  isRegistered: boolean;
  player?: PlayerData;
  isUserAlsoPlayer?: boolean;
  createUrl?: string;
}

export function getNoResultsConfig({
  moduleType,
  isManage,
  isRegistered,
  player,
  isUserAlsoPlayer,
  createUrl,
}: NoResultsConfigProps) {
  const cdnUrl = publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL ?? '';
  const baseIllustration = getCDNURL(
    `${cdnUrl}/global/empty-dataset/PB-empty-dataset-alt.svg`,
    320,
    233
  );
  const { singular, plural, createAction, exploreAction, exploreUrl } =
    NO_RESULTS_MODULE_MESSAGES[moduleType];
  const playerName = player ? `${player.firstName} ${player.lastNameAndSuffix}` : 'This player';

  const text = `No ${isManage ? 'Managed' : isRegistered ? 'Registered' : 'Favorited'} ${plural}`;

  const description = !isUserAlsoPlayer
    ? `${playerName} is not ${isManage ? 'managing' : isRegistered ? 'registered for' : 'favoriting'} any ${plural.toLowerCase()}.`
    : isManage
      ? `Create a ${singular.toLowerCase()} and compete with others now!`
      : isRegistered
        ? `Find and join ${plural.toLowerCase()} that match your skill level and compete for top spots`
        : `Explore all the ${plural.toLowerCase()} around you and add them to your favorites`;

  const buttonLink = isUserAlsoPlayer
    ? isManage
      ? (createUrl ?? NO_RESULTS_MODULE_MESSAGES[moduleType].createUrl)
      : exploreUrl
    : undefined;

  const buttonText = isUserAlsoPlayer
    ? isManage
      ? createAction
      : isRegistered
        ? exploreAction
        : plural
    : undefined;

  return {
    text,
    description,
    buttonLink,
    buttonText,
    illustrationUrl: baseIllustration,
    cdnUrl,
  };
}

export function getProperModuleTypeStatusOrRedirect<T>(
  value: T | undefined,
  redirectTo: string
): T {
  if (value === undefined) redirect(redirectTo);
  return value;
}
